import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ConfigService } from '../service/config.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appPortalFeature]',
  standalone: true,
})
export class PortalFeatureDirective implements OnInit, OnDestroy {
  @Input() appPortalFeature!: string;
  @Input() needToCheckLogin: boolean = false;

  private configSubscription?: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private configService: ConfigService,
  ) {}

  ngOnInit() {
    // Subscribe to config changes
    this.configSubscription = this.configService
      .getConfig$()
      .subscribe((config) => {
        this.updateView(config);
      });

    // Initial view update
    const currentConfig = this.configService.getConfig();
    this.updateView(currentConfig);
  }

  ngOnDestroy() {
    if (this.configSubscription) {
      this.configSubscription.unsubscribe();
    }
  }

  private updateView(config: any) {
    this.viewContainer.clear();

    const loggedIn = JSON.parse(localStorage.getItem('login') || 'false');

    let shouldShow = false;

    if (
      this.appPortalFeature === 'login' ||
      this.appPortalFeature === 'profile'
    ) {
      shouldShow = this.shouldShowAuthElement(config, loggedIn);
    } else if (this.appPortalFeature) {
      const isFeatureEnabled = this.isFeatureEnabled(config);
      shouldShow = isFeatureEnabled;
    } else {
      shouldShow = false;
    }

    console.log(
      `PortalFeatureDirective [${this.appPortalFeature}]: shouldShow=${shouldShow}, loggedIn=${loggedIn}`,
    );

    if (shouldShow) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  private isFeatureEnabled(config: any): boolean {
    const getFeatureValue = (value: string | undefined): boolean => {
      if (value === null || value === undefined || value === '') {
        return true;
      }
      return value.toLowerCase() === 'true';
    };

    switch (this.appPortalFeature) {
      case 'registration':
        return getFeatureValue(config.registrationFeatureEnabled);
      case 'invoice':
        return getFeatureValue(config.invoiceFeatureEnabled);
      case 'signup':
        return getFeatureValue(config.signupAndProfilingEnabled);
      case 'invoiceHistory':
        return getFeatureValue(config.invoiceHistoryEnabled);
      case 'purchaseHistory':
        return getFeatureValue(config.purchaseHistoryEnabled);
      case 'changeRequests':
        return getFeatureValue(config.changeRequestsEnabled);

      default:
        return false;
    }
  }

  private shouldShowAuthElement(config: any, loggedIn: boolean): boolean {
    const signupEnabled = config.signupAndProfilingEnabled?.toLowerCase();

    const isSignupEnabled =
      signupEnabled === null ||
      signupEnabled === undefined ||
      signupEnabled === '' ||
      signupEnabled === 'true';

    if (this.appPortalFeature === 'login') {
      return !loggedIn && isSignupEnabled;
    } else if (this.appPortalFeature === 'profile') {
      return loggedIn && isSignupEnabled;
    }

    return false;
  }
}
